import PrimeCreationContainer from "./PrimeCreationContainer";
import PrimeCreationStore from "./PrimeCreationStore";

export default PrimeCreationStore(PrimeCreationContainer);
